import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import Media from 'react-media';
import { mediaQueries } from '@eti/styles';
import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import { useScroll } from '@eti/utils';
import StickySidebar from '../../sidebar/components/StickySidebar';
import MobileCart from '../../../pages/traveler-details/components/mobile-cart/MobileCart';
import { transformCartProducts } from '../../../pages/receipt/utils/receiptCartProductsUtil';
import { routes } from '../../../constants/routesAndApisConstants';
import OrderContent from './OrderContent';

const OrderInfo = ({ addedExtraProducts = [], isLoading, order = {}, cartRef, totalPrice }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { extraProducts = [], bounds = [], addedAncillaryBundles = [] } = order;
  const isOrderDetailsPage = pathname.includes(routes.ORDER_DETAILS);

  const { isScrollingUp } = useScroll({
    maxScreenWidth: null,
    throttleTime: 100,
    useCaptionOnScrollListener: true,
  });

  const getTopSpacing = useCallback(() => {
    if (!isOrderDetailsPage) {
      return 88;
    }
    if (isScrollingUp) {
      return 137;
    }
    return 69;
  }, [isOrderDetailsPage, isScrollingUp]);

  return (
    <Media query={mediaQueries.large.up}>
      {(matches) =>
        matches ? (
          <StickySidebar containerRef={cartRef} topSpacing={getTopSpacing()}>
            <OrderContent
              addedAncillaryBundles={addedAncillaryBundles}
              addedExtraProducts={addedExtraProducts}
              bounds={bounds}
              extraProducts={transformCartProducts(
                t,
                extraProducts,
                bounds,
                order?.travelers?.length,
              )}
              isLoading={isLoading}
              title={t('Postbooking.Widget.Title')}
              totalPrice={totalPrice}
            />
          </StickySidebar>
        ) : (
          <MobileCart addedProductsNumber={addedExtraProducts?.length} totalPrice={totalPrice}>
            <OrderContent
              addedAncillaryBundles={addedAncillaryBundles}
              addedExtraProducts={addedExtraProducts}
              bounds={bounds}
              extraProducts={extraProducts}
              isLoading={isLoading}
              totalPrice={totalPrice}
            />
          </MobileCart>
        )
      }
    </Media>
  );
};

OrderInfo.propTypes = {
  addedExtraProducts: PropTypes.arrayOf(PropTypes.object),
  cartRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  isLoading: PropTypes.bool,
  order: PropTypes.objectOf(PropTypes.any),
  totalPrice: PropTypes.number,
};

export default OrderInfo;
